import React from 'react'
import { Outlet } from "react-router-dom";
import NavBar from './NavBar/NavBar';
import TitleBar from './TitleBar/TitleBar';
import SubMenu from './SubMenu/SubMenu';


const Dashboard = () => {
  return (
   <>
    <NavBar />
      <div className="container-fluid bg-main">
        <div className="row mb-1">
          <div className="col-12">
            {/* <div className="row">
              <div className="col-12 p-0">
                <TitleBar />
              </div>
            </div> */}
            <div className="row p-1 bg-nav">
              <div className="col-md-2 col-sm-12 mt-2 px-1">
                <SubMenu />
              </div>
              <div className="col-md-10 col-sm-12">
                <div className="row mt-2">
                  <div className="col-12 px-1">
                    <Outlet />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
   </>
  )
}

export default Dashboard